import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class BankAccount {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  bankName!: string;
  @Expose()
  @IsString()
  iban!: string;
  @Expose()
  @IsString()
  swift!: string;
  @Expose()
  @IsString()
  accountNumber!: string;
  @Expose()
  @IsString()
  accountCurrency!: string;
}

export class BankAccountIdOnly {
  @Expose()
  @IsNumber()
  id!: number;
}

export class BankAccountWithDefault {
  @Expose()
  @Type(() => BankAccount)
  @IsArray()
  @ValidateNested()
  bankAccounts!: BankAccount[] | null;
  @Expose()
  @IsOptional()
  @Type(() => BankAccount)
  @ValidateNested()
  defaultBankAccount!: BankAccountIdOnly | null;
}

export default class GetContractorForRequestForPaymentResponse {
  @Expose()
  @IsString()
  contractorId!: string;
  @Expose()
  @IsString()
  contractorName!: string;
  @Expose()
  @IsBoolean()
  hasOverdueDocument!: boolean;
  @Expose()
  @Type(() => BankAccountWithDefault)
  @ValidateNested()
  bankAccount!: BankAccountWithDefault;
  @Expose()
  paymentDaysCount!: number;
}
